import { render, staticRenderFns } from "./VideoSubComponent.vue?vue&type=template&id=6812af99&scoped=true&"
import script from "./VideoSubComponent.vue?vue&type=script&lang=ts&"
export * from "./VideoSubComponent.vue?vue&type=script&lang=ts&"
import style0 from "./VideoSubComponent.vue?vue&type=style&index=0&id=6812af99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6812af99",
  null
  
)

export default component.exports